// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3289db2c","28":"c912557a","39":"fa555c58","53":"ba7ea882","420":"b3b59f3c","787":"e8b2cf0e","875":"0d178ac0"}[chunkId] + ".chunk.js";
};